import React from "react";

export const WithBorderBetween = ({ children }) => (
  <div className="divide-y divide-gray-200">{children}</div>
);

export const WithSpacesBetween = ({ children }) => <div className="space-y-6">{children}</div>;
